import { loop } from 'product-icon';
import { $, $$ } from 'query-selector';
import Glide, { Controls, Swipe } from 'glide';

export default () => {
  const slider = $('.js-product-slider');
  if (!slider) return;

  const productIcons = $$('.js-product-icon', slider);
  for (const icon of productIcons) loop(icon);

  const glide = new Glide(slider, {
    type: 'slider', // carousel
    rewind: true,
    gap: 6,
    animationDuration: 700,
    dragThreshold: false,
    swipeThreshold: 60,
    animationTimingFunc: 'ease'
  }).mount({ Controls, Swipe });
};
